export default function (time) {
    const Minute = Math.floor(time / 60000)
    const Seconds = (time % 60000) / 1000
    return `${(Minute < 10) ? `0${ Minute }`: Minute}:${(Seconds < 10) ? `0${ Seconds }`: Seconds}`
}
